import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NgxEchartsDirective } from 'ngx-echarts';
import { DateRangeSelectorComponent } from '../../../basic/date-range-selector/date-range-selector.component';
import { ToLocaleFormat } from '../../../basic/pipes/to-locale-format.pipe';
import { TruncatePipe } from '../../../basic/pipes/truncate.pipe';
import { LeadsTimeRangeData } from '../../../core/leads/leads';
import { BasicPageComponent } from '../../../pages/_shared/basic-page/basic-page.component';
import { BoardIconComponent } from '../../board/board-icon/board-icon.component';

@Component({
  selector: 'app-leads-time-range-card',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzPopconfirmModule,
    NzTabsModule,
    NzMessageModule,
    NzSelectModule,
    NzDropDownModule,
    NzTagModule,

    TruncatePipe,

    MatTooltip,

    BasicPageComponent,
    DateRangeSelectorComponent,
    BoardIconComponent,

    NgxEchartsDirective,

    NzStatisticModule,

    ToLocaleFormat,
  ],
  templateUrl: './leads-time-range-card.component.html',
  styleUrl: './leads-time-range-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadsTimeRangeCardComponent {
  @Input() data?: LeadsTimeRangeData;
}
